/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */

 /*
  * This set of functions is necessary to detect NA client window opening
  * because current NA client does not include any means to report its state.
  * The idea for most browsers is the same: detection of focus transferring
  * from browser window. Because old-style NA-webtop may have no selectable
  * elements, some special DOM element is created to grab focus (for Chrome/FF
  * and old IE). For Safari, new window is opened. For late IE versions,
  * special method (navigator.msLaunchUri()) id used.
  *
  * Original version has been introduced in CL 1495661 / RB 146019.
  * This RB request contains some test HTML page which shows the idea.
  */
function createFrame(name, doc) {
    if (doc == null) {
        doc = document;
    }
    var frameName = name + '_frame';
    var launchFrame = doc.getElementById(frameName);

    if (launchFrame != null) {
        launchFrame.parentNode.removeChild(launchFrame);
        launchFrame = null;
    }

    if (launchFrame == null) {
        launchFrame = doc.createElement('iframe');
        launchFrame.id = frameName;
        launchFrame.name = frameName; // name is used for window.open
        launchFrame.style.visibility = "hidden";
        launchFrame.height = 0;
        doc.body.appendChild(launchFrame);
    }

    return frameName;
}

var handlerDetectionResult = {
    notDetected: 0,
    detected: 1,
    unknown: 2
};

var handlerExecutionResult = {
    userAllowed: 0,
    userDeclined: 1,
    unknown: 2
};

function isIE10orBelow() {
    // IE11 doesn't have MSIE in userAgent
    return (navigator.userAgent.match(/MSIE/i));
}

function launchEdge(url, callback, popupBlockedCallback) {
    launchIE(url, callback, popupBlockedCallback);
}

function launchIEPopupCheck(url, myWindow, callback, enforceIFrame) {
    var detectionRes = handlerDetectionResult.detected;
    try {
        if (enforceIFrame || isIE10orBelow()) {
            myWindow.document.write("<iframe src='" + url + "'>" + "</iframe>");
        } else {
            try {
                myWindow.location.href = url;
            } catch (e) {
                // exception is thrown when current site isn't in trusted sites
                // list, so falling back to iframe in pop-up based approach
                launchIEPopupCheck(url, myWindow, callback, true);
                return;
            }
        }
        setTimeout(function() {
            try {
                myWindow.location.href;
            } catch (ex) {
                detectionRes = handlerDetectionResult.notDetected;
            }

            function closeWindow(w) {
                // There is an issue that we can't close pop-up window if
                // current site isn't in trusted sites list and no app installed
                //
                // This happens because IE revokes control of pop which
                // navigates to different URI (and it really does - as we ask
                // pop-up to go to 'url')
                if (w) {
                    w.close();
                }
            }

            if (detectionRes) {
                setTimeout(closeWindow.bind(null, myWindow), 100);
            } else {
                closeWindow(myWindow);
            }

            callback(detectionRes);
        }, 200);
    } catch (e) {
        callback(handlerDetectionResult.notDetected);
    }
}

function launchIE(url, callback, popupBlockedCallback) {
    if (navigator.msLaunchUri) {
        var userClickedCancel = true;
        // only windows 8+ plus IE10+ goes here
        navigator.msLaunchUri(url,
            function() {
                userClickedCancel = false;
                callback(handlerDetectionResult.detected, handlerExecutionResult.userAllowed);
            },
            function() {
                userClickedCancel = false;
                callback(handlerDetectionResult.notDetected);
            }
        );
        // no events will be fired if user presses cancel for prompt
        // (do you really want to run...) so we need to handle this.
        // * if application isn't installed second handler is called almost
        // immediately setting userClickedCancel to false - no actions from out side
        // * if application is installed first handler may be called or may be
        // not depending on user decision wether to run or not. That dialog
        // is blocking, however was scheduled asynchronously, so settings 500ms
        // delay puts our closure behind IE dialog closure in the JS queue,
        // thus the closure is guaranteed to be executed after user makes a
        // decision. At that point we know for sure whether user cancelled the
        // dialog (userClickedCancel var) or not
        setTimeout(function() {
                if (userClickedCancel) {
                    callback(handlerDetectionResult.detected, handlerExecutionResult.userDeclined);
                }
            }, 500);
        return;
    }

    var success = true;
    var myWindow = window.open("", "", "width=100, height=50, location=no, "
        + "style='visibility:hidden', toolbar=no, status=no, menubar=no,"
        + " scrollbars=no");
    if (!myWindow) {
        if (popupBlockedCallback) {
            setTimeout(popupBlockedCallback, 1);
        }
        return;
    }
    myWindow.document.write("<script>setTimeout('window.close()', 2 * 1000);</script>Launching...");
    setTimeout(launchIEPopupCheck.bind(null, url, myWindow, callback), 300);
}

function launchFirefox(url, callback) {
    var detectionRes = handlerDetectionResult.detected;
    try {
        var iframeName = createFrame("launch");
        var iframe = document.getElementById(iframeName);
        iframe.contentWindow.location.href = url;
    } catch (ex) {
        detectionRes = handlerDetectionResult.notDetected;
    }
    if (iframe != null) {
        iframe.remove();
    }

    callback(detectionRes);
}

function launchChrome(url, callback) {
    var timeoutId = 0;
    var _cleanup = null;
    var elem = document.createElement("input");
    elem.id = 'launch' + Math.random();
    elem.style.position = "absolute";
    elem.style.backgroundColor = "transparent";
    elem.style.borderWidth = 0;
    elem.placeholder = '';
    // we need to put this to very beginning of body in order to get
    // this element visible
    document.body.insertBefore(elem, document.body.firstChild);

    var blurHandler = function() {
        window.clearTimeout(timeoutId);
        _cleanup();
        callback(handlerDetectionResult.detected);
    };

    _cleanup = function() {
        window.removeEventListener('blur', blurHandler);
        document.body.removeChild(elem);
    };

    timeoutId = window.setTimeout(function() {
        _cleanup();
        callback(handlerDetectionResult.notDetected);
    }, 3000);

    window.addEventListener('blur', blurHandler);
    location.href = url;
}

function launchSafariNoCallback(url) {
    var fn = createFrame("launch" + Math.random());
    var ifrm = document.getElementById(fn);
    var v = window.open(url, fn);
}

function isSafari10() {
    var m = navigator.userAgent.match(/version\/([\d\.]+)/i);
    var ver = "9.0.0"; // default version
    if (m && m[1]) {
        ver = m[1];
    }
    var verMajor = ver.split('.')[0];
    return verMajor == 10;
}

function safariCallback(realCb, url, detectionRes) {
    if (isSafari10() && (detectionRes == handlerDetectionResult.detected)) {
         location.href = url;
    }
    realCb(detectionRes);
}

// onload non-complaint
function launchSafari(url, callback) {
    var v = window.open('', '');

    if (typeof v === "undefined" || v == null) {
       v = window;
    }
    v.location.href = url;

    setTimeout(function() {
        var detectionRes = handlerDetectionResult.notDetected;
        try {
            if (typeof v.location.href != "undefined") {
                detectionRes = handlerDetectionResult.detected;
            }
        } catch (e) {}
        if (v !== window) { v.close(); }
        callback(detectionRes);
    }, 300);
}
//MacOS 13.3 fix, revert when EdgeClient is upgraded.
function launchMacStandalone(url, callback) {
    var v = window
    v.location.href = url;
    setTimeout(function() {
        var detectionRes = handlerDetectionResult.notDetected;
        try {
            if (typeof v.location.href != "undefined") {
                detectionRes = handlerDetectionResult.detected;
            }
        } catch (e) {}
        if (v !== window) { v.close(); }
        callback(detectionRes);
    }, 300);
}

var browser_id = {
    ie: "IE",
    chrome: "Chrome",
    firefox: "Firefox",
    safari: "Safari",
    edge: "Edge",
    standAlone : "MacEdgeClient"
};

function getBrowser() {
    var browser = browser_id.ie;
    if (navigator.userAgent.indexOf("MacEdgeClient") > 0) {
        browser = browser_id.standAlone;
    } else if (navigator.userAgent.indexOf("Edge") > 0) {
        browser = browser_id.edge;
    } else if (navigator.userAgent.indexOf("Chrome") > 0) {
        browser = browser_id.chrome;
    } else if (navigator.userAgent.indexOf("Firefox") > 0) {
        browser = browser_id.firefox;
    } else if (navigator.userAgent.indexOf("Safari") > 0) {
        browser = browser_id.safari;
    } else if (navigator.userAgent.indexOf("Macintosh") > 0 &&
            navigator.userAgent.indexOf("AppleWebKit") > 0)  {
        // Office App Safari
        browser = browser_id.safari;
    }
    return browser;
}

function isCustomProtocolDetectionSupported() {
    return true;
}

function launchCustomProtocol(url, callback, popupBlockedCallback, silent) {
    var browser = getBrowser();

    var safePolling = (browser === browser_id.firefox);
    var _callback = callback;
    callback = function(detectionResult, executionResult) {
        if (typeof executionResult === "undefined") {
            executionResult = handlerExecutionResult.unknown;
        }
        _callback(url, !silent, detectionResult, executionResult, safePolling);
    };

    if (browser === browser_id.standAlone) {
        launchMacStandalone(url, callback, popupBlockedCallback);
    } else if (browser === browser_id.ie) {
        launchIE(url, callback, popupBlockedCallback);
    } else if (browser === browser_id.edge) {
        launchEdge(url, callback, popupBlockedCallback);
    } else if (browser === browser_id.firefox) {
        launchFirefox(url, callback);
    } else if (browser === browser_id.chrome) {
        launchChrome(url, callback, popupBlockedCallback);
    } else if (browser === browser_id.safari) {
        var safariCb = safariCallback.bind(null, callback, url);
        if (silent) {
            // safary blocks pop-ups from onload events, that's why
            // this if is required
            launchSafariNoCallback(url, safariCb, popupBlockedCallback);
        } else {
            launchSafari(url, safariCb, popupBlockedCallback);
        }
    }
}

export {
    handlerDetectionResult,
    handlerExecutionResult,
    isCustomProtocolDetectionSupported,
    launchCustomProtocol,
};
